module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Br3lUq/tc-custom/9781636982595.jpg?1736222097984",
      "alt": "This image is the cover for the book Art of Doubling Down"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Art of Doubling Down\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Successful people do not avoid failure, but rather use it as a steppingstone to reach their goals.")]), _c('p', [_vm._v("For too long people have been defeated by the idea that life stops when you fail. In The Art of Doubling Down, authorAnthonyMichael Russoturns this idea on its head, proving that failure is far from the end of the road. ")]), _c('p', [_vm._v("The Art of Doubling Down highlights stories of successful people who experienced failure and leveraged it as a learning opportunity to become stronger and more resilient. He also dives into his personal experience growing up with a father who had a gambling addiction that almost destroyed their family, to demonstrate how failure ended up being the key to unlocking success in his own life.")]), _c('p', [_vm._v("Through these inspirational stories and practical tips, individuals can learn how to transform their fear of failure into motivation to face challenges head-on. Theorists will become practitioners who are ready to take on life with a new outlook. And discover how to identify the lesson inside every failure that paves the way towards success in business, life, and finding ultimate happiness.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anthony  Michael Russo\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0